import { Stack, Typography } from "@mui/material";
import { BorderLinearProgress } from "./BorderLinearProgress";
import { formatearNumeroConComas } from "views/Components/Shared/utils/formatNumbers";

export default function GapCosumedCell({ gapConsumed }) {
  if (!gapConsumed) return "-";
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={0.5}
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: "#00000099", fontSize: "12px", fontWeight: 400 }}
        >
          Presupuesto:
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          alignContent="center"
          justifyContent="flex-end"
          sx={{ width: "100%" }}
        >
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{
              color: "#000000DE",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            ${formatearNumeroConComas(gapConsumed?.current)}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{
              color: "#00000099",
              fontSize: "12px",
              fontWeight: 400,
            }}
          >
            / ${formatearNumeroConComas(gapConsumed?.total)}
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ width: "100%" }}>
        <BorderLinearProgress
          variant="determinate"
          value={Number(gapConsumed?.percentage?.toFixed(2)) || 0}
        />
      </Stack>
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{ color: "#00000099", fontSize: "12px", fontWeight: 400 }}
          >
            Ritmo:
          </Typography>
          {gapConsumed?.rhythm === "warning" && (
            <SpeedIcon sx={{ width: "16px", height: "16px" }} />
          )}
        </Stack>
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{
            color: gapConsumed?.rhythm === "warning" ? "#EF6C00" : "#002878",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {gapConsumed?.percentage?.toFixed(2)}%
        </Typography>
      </Stack>
    </Stack>
  );
}

const SpeedIcon = ({ sx }) => (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={sx}
  >
    <path
      d="M10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0ZM10.5 1.5C9.30653 1.5 8.16193 1.97411 7.31802 2.81802C6.47411 3.66193 6 4.80653 6 6C6 7.19347 6.47411 8.33807 7.31802 9.18198C8.16193 10.0259 9.30653 10.5 10.5 10.5C11.6935 10.5 12.8381 10.0259 13.682 9.18198C14.5259 8.33807 15 7.19347 15 6C15 4.80653 14.5259 3.66193 13.682 2.81802C12.8381 1.97411 11.6935 1.5 10.5 1.5ZM9.75 3H10.875V5.835L12.6225 7.5825L11.8275 8.3775L9.75 6.3V3ZM0.75 10.5C0.551088 10.5 0.360322 10.421 0.21967 10.2803C0.0790176 10.1397 0 9.94891 0 9.75C0 9.55109 0.0790176 9.36032 0.21967 9.21967C0.360322 9.07902 0.551088 9 0.75 9H3.6225C3.855 9.5325 4.155 10.035 4.5 10.5H0.75ZM1.5 6.75C1.30109 6.75 1.11032 6.67098 0.96967 6.53033C0.829018 6.38968 0.75 6.19891 0.75 6C0.75 5.80109 0.829018 5.61032 0.96967 5.46967C1.11032 5.32902 1.30109 5.25 1.5 5.25H3.0375L3 6L3.0375 6.75H1.5ZM2.25 3C2.05109 3 1.86032 2.92098 1.71967 2.78033C1.57902 2.63968 1.5 2.44891 1.5 2.25C1.5 2.05109 1.57902 1.86032 1.71967 1.71967C1.86032 1.57902 2.05109 1.5 2.25 1.5H4.5C4.155 1.965 3.855 2.4675 3.6225 3H2.25Z"
      fill="#FF9800"
    />
  </svg>
);
